import {
  Container,
  Grid,
  Box,
  makeStyles,
  useTheme,
  useMediaQuery,
  Slide,
  Fade,
  Grow,
  Typography,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Loading } from "../../components/shared/loading";
import FormatQuoteIcon from "@material-ui/icons/FormatQuote";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { TypingQuote } from "../../components/shared/TypingQuote";
import { HeroParticles } from "../../components/shared/HeroParticles";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  "@keyframes heroFadeUp": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes heroExpand": {
    from: { width: 0, opacity: 0 },
    to: { width: 90, opacity: 1 },
  },
  "@keyframes heroShimmerSweep": {
    "0%": { backgroundPosition: "-200% center" },
    "100%": { backgroundPosition: "200% center" },
  },
  heroSection: {
    position: "relative",
    overflow: "hidden",
    minHeight: "45vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background:
      "linear-gradient(135deg, #1a001a 0%, #2d002d 50%, #1a001a 100%)",
  },
  heroContent: {
    position: "relative",
    zIndex: 2,
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    backgroundImage:
      "linear-gradient(90deg, #ffffff 0%, #e0b8e0 25%, #c77dc7 50%, #e0b8e0 75%, #ffffff 100%)",
    backgroundSize: "200% auto",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "transparent",
    animation:
      "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both, $heroShimmerSweep 5s linear infinite",
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
    animation: "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.5s both",
  },
  heroDivider: {
    width: 90,
    height: 3,
    background:
      "linear-gradient(90deg, transparent, #c77dc7 30%, #e0b8e0 50%, #c77dc7 70%, transparent)",
    margin: "16px auto",
    borderRadius: 2,
    animation: "$heroExpand 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both",
  },
  section: {
    padding: "40px 0",
    [theme.breakpoints.down('sm')]: {
      padding: "28px 0",
    },
  },
  sectionAlt: {
    padding: "40px 0",
    background: "#fafafa",
    [theme.breakpoints.down('sm')]: {
      padding: "28px 0",
    },
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 450,
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  contentCard: {
    background: "#ffffff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    [theme.breakpoints.down('sm')]: {
      padding: "20px",
    },
  },
  contentText: {
    fontSize: "0.85rem",
    color: "#444444",
    lineHeight: 1.7,
    "& p": {
      marginBottom: 12,
    },
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      color: "#4c004c",
      marginTop: 16,
      marginBottom: 8,
      fontSize: "1rem",
    },
    "& ul, & ol": {
      paddingLeft: 20,
      marginBottom: 12,
    },
    "& li": {
      marginBottom: 6,
    },
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "12px",
    padding: "28px 24px",
    textAlign: "center",
  },
  quoteIcon: {
    fontSize: 28,
    color: "rgba(255, 255, 255, 0.15)",
    display: "block",
    margin: "0 auto 10px",
  },
  quoteText: {
    fontSize: "0.9rem",
    color: "#ffffff",
    lineHeight: 1.6,
    fontStyle: "italic",
    textAlign: "center",
    maxWidth: 700,
    margin: "0 auto 12px",
  },
  quoteAuthor: {
    color: "#ffffff",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: 600,
    opacity: 0.9,
  },
  valueCard: {
    background: "#ffffff",
    borderRadius: "12px",
    padding: "20px",
    height: "100%",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    transition: "all 0.2s ease",
    textAlign: "center",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 24px rgba(107, 27, 107, 0.1)",
    },
  },
  collabCard: {
    background: "linear-gradient(160deg, #1a0a1a 0%, #2d0e2d 40%, #3d1a3d 100%)",
    borderRadius: 24,
    padding: "36px 28px 28px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    border: "1px solid rgba(155, 59, 155, 0.12)",
    transition: "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      width: "50%",
      height: "50%",
      background: "radial-gradient(circle at 100% 0%, rgba(155,59,155,0.12) 0%, transparent 70%)",
      pointerEvents: "none",
    },
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 24px 60px rgba(76, 0, 76, 0.25)",
      borderColor: "rgba(155, 59, 155, 0.25)",
    },
    "&:hover $collabLogoWrapper": {
      borderColor: "rgba(155, 59, 155, 0.35)",
      boxShadow: "0 0 24px rgba(155, 59, 155, 0.15)",
    },
    "&:hover $collabVisitBtn": {
      background: "rgba(155, 59, 155, 0.2)",
      borderColor: "rgba(155, 59, 155, 0.4)",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "28px 22px 24px",
      borderRadius: 20,
    },
  },
  collabLogoWrapper: {
    width: 110,
    height: 110,
    borderRadius: 22,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    marginBottom: 20,
    overflow: "hidden",
    border: "1px solid rgba(155, 59, 155, 0.15)",
    transition: "all 0.4s ease",
    [theme.breakpoints.down('sm')]: {
      width: 90,
      height: 90,
      borderRadius: 18,
    },
  },
  collabLogo: {
    maxWidth: "80%",
    maxHeight: "80%",
    objectFit: "contain",
    border: "none",
  },
  collabLogoFallback: {
    fontSize: "0.65rem",
    fontWeight: 700,
    color: "rgba(255,255,255,0.7)",
    textAlign: "center",
    lineHeight: 1.2,
  },
  collabName: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#ffffff",
    marginBottom: 4,
    position: "relative",
    zIndex: 1,
  },
  collabRole: {
    fontSize: "0.68rem",
    fontWeight: 500,
    color: "#c77dc7",
    textTransform: "uppercase",
    letterSpacing: "1.5px",
    marginBottom: 16,
    position: "relative",
    zIndex: 1,
  },
  collabDesc: {
    fontSize: "0.82rem",
    color: "rgba(255,255,255,0.6)",
    lineHeight: 1.7,
    marginBottom: 10,
    textAlign: "left",
    position: "relative",
    zIndex: 1,
  },
  collabBullets: {
    fontSize: "0.78rem",
    color: "rgba(255,255,255,0.55)",
    lineHeight: 1.6,
    paddingLeft: 18,
    marginBottom: 12,
    textAlign: "left",
    alignSelf: "flex-start",
    position: "relative",
    zIndex: 1,
    "& li": {
      marginBottom: 4,
    },
  },
  collabLink: {
    marginTop: "auto",
    paddingTop: 14,
    display: "flex",
    alignItems: "center",
    gap: 8,
    textDecoration: "none",
    position: "relative",
    zIndex: 1,
    "&:hover": {
      textDecoration: "none",
    },
  },
  collabVisitBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 20px",
    borderRadius: 14,
    background: "rgba(155, 59, 155, 0.1)",
    border: "1px solid rgba(155, 59, 155, 0.2)",
    color: "#d4a0d4",
    fontSize: "0.76rem",
    fontWeight: 500,
    letterSpacing: "0.3px",
    transition: "all 0.3s ease",
  },
  valueTitle: {
    fontSize: "0.9rem",
    fontWeight: 600,
    color: "#4c004c",
    marginBottom: 8,
  },
  valueText: {
    fontSize: "0.78rem",
    color: "#666666",
    lineHeight: 1.5,
  },
}));

export const AboutUs = () => {
  const theme = useTheme();

  const classes = useStyles();
  const [data, setData] = useState();
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 6);
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        setIsloading(false);
        handleClick();
      }
    });
    Axios.post("/api/select_aboutus", {
      headers: { headKey: headKey },
    }).then((res) => {
      console.log("hit");
      console.log(res.data.status);
      if (res.data.status) {
        console.log(res.data.status);
        setData(ReactHtmlParser(res.data.data.description));
      }
    });
  };

  const values = [
    { title: "Innovation", text: "Pushing boundaries with new technology" },
    { title: "Excellence", text: "Delivering quality that exceeds expectations" },
    { title: "Integrity", text: "Building trust through transparent partnerships" },
    { title: "Collaboration", text: "Working together to achieve shared success" },
  ];

  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet>

      {isloading ? (
        <Loading />
      ) : (
        <>
          {/* Hero Section */}
          <Box className={classes.heroSection}>
            <HeroParticles id="aboutus-hero-particles" />
            <Box className={classes.heroContent}>
              <Typography className={classes.heroTitle}>
                About Us
              </Typography>
              <Box className={classes.heroDivider} />
              <Typography className={classes.heroSubtitle}>
                Crafting Excellence Through Unique IT Services - Transforming Ideas Into Powerful Digital Solutions Since 2018
              </Typography>
            </Box>
          </Box>

          {/* Story Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Story & Vision
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Learn about our journey, values, and the drive behind our innovations
                  </Typography>
                </Box>
              </Slide>

              <Fade in={true} timeout={1000}>
                <Box className={classes.contentCard}>
                  <Box className={classes.contentText}>
                    {data}
                  </Box>
                </Box>
              </Fade>
            </Container>
          </Box>

          {/* Collaborations Section */}
          <Box className={classes.sectionAlt}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Collaborations
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Strategic partnerships powering innovation, AI transformation, and scalable engineering
                  </Typography>
                </Box>
              </Slide>

              <Grid container spacing={3} justifyContent="center">
                {/* ScaleMe.in */}
                <Grid item xs={12} md={6}>
                  <Grow in={true} timeout={600}>
                    <Box className={classes.collabCard}>
                      <Box className={classes.collabLogoWrapper}>
                        <img
                          src="/static/scaleme.png"
                          alt="ScaleMe.in"
                          className={classes.collabLogo}
                          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
                        />
                        <Typography className={classes.collabLogoFallback} style={{ display: 'none' }}>Scale<br/>Me</Typography>
                      </Box>
                      <Typography className={classes.collabName}>ScaleMe.in</Typography>
                      <Typography className={classes.collabRole}>AI Technology Advisory Partner</Typography>
                      <Typography className={classes.collabDesc}>
                        ScaleMe.in is a growth ecosystem for Indian SMEs, enabling them to connect with experts, access knowledge, and explore capital opportunities. Arawinz works as their AI Technology Advisory Partner, designing and implementing:
                      </Typography>
                      <ul className={classes.collabBullets}>
                        <li>AI-based networking systems for events</li>
                        <li>WhatsApp & voice-based automation for SME engagement</li>
                        <li>AI-driven lead discovery and matchmaking tools</li>
                        <li>Internal productivity and communication automations</li>
                      </ul>
                      <a href="https://scaleme.in" target="_blank" rel="noopener noreferrer" className={classes.collabLink}>
                        <Box className={classes.collabVisitBtn}>
                          Visit ScaleMe.in <ArrowForwardIcon style={{ fontSize: 14 }} />
                        </Box>
                      </a>
                    </Box>
                  </Grow>
                </Grid>

                {/* Ziplo.ai */}
                <Grid item xs={12} md={6}>
                  <Grow in={true} timeout={800}>
                    <Box className={classes.collabCard}>
                      <Box className={classes.collabLogoWrapper}>
                        <img
                          src="/static/zaplo.png"
                          alt="Ziplo.ai"
                          className={classes.collabLogo}
                          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
                        />
                        <Typography className={classes.collabLogoFallback} style={{ display: 'none' }}>Ziplo<br/>.ai</Typography>
                      </Box>
                      <Typography className={classes.collabName}>Ziplo.ai</Typography>
                      <Typography className={classes.collabRole}>Enterprise AI Agent Testing Partner</Typography>
                      <Typography className={classes.collabDesc}>
                        Arawinz has a strategic collaboration with Ziplo.ai, a platform focused on testing, validating, and governing enterprise AI agents. Through this partnership, Arawinz delivers:
                      </Typography>
                      <ul className={classes.collabBullets}>
                        <li>AI agent reliability and stress testing</li>
                        <li>Governance, compliance & enterprise-grade observability</li>
                        <li>Evaluation workflows for LLM-powered systems</li>
                        <li>Organizational readiness and AI workforce uplift</li>
                      </ul>
                      <a href="https://ziplo.ai" target="_blank" rel="noopener noreferrer" className={classes.collabLink}>
                        <Box className={classes.collabVisitBtn}>
                          Visit Ziplo.ai <ArrowForwardIcon style={{ fontSize: 14 }} />
                        </Box>
                      </a>
                    </Box>
                  </Grow>
                </Grid>

                {/* CodeSquare Labs - commented out for now
                <Grid item xs={12} md={4}>
                  <Grow in={true} timeout={1000}>
                    <Box className={classes.collabCard}>
                      <Box className={classes.collabLogoWrapper}>
                        <img
                          src="/static/csl.png"
                          alt="CodeSquare Labs"
                          className={classes.collabLogo}
                          onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
                        />
                        <Typography className={classes.collabLogoFallback} style={{ display: 'none' }}>Code<br/>Square</Typography>
                      </Box>
                      <Typography className={classes.collabName}>CodeSquare Labs</Typography>
                      <Typography className={classes.collabRole}>Engineering & Product Development Partner</Typography>
                      <Typography className={classes.collabDesc}>
                        Arawinz partners with CodeSquare Labs, a digital marketing and IT services firm, delivering complete product engineering as a two-team engine:
                      </Typography>
                      <ul className={classes.collabBullets}>
                        <li>CSL drives sales, branding, and digital marketing strategies</li>
                        <li>Arawinz builds and maintains websites, mobile apps, backend systems, and cloud infrastructure</li>
                      </ul>
                      <Typography className={classes.collabDesc} style={{ marginBottom: 0 }}>
                        Together, we deliver full-stack solutions helping CSL's clients scale with stable, secure digital platforms.
                      </Typography>
                      <a href="https://codesquarelabs.com" target="_blank" rel="noopener noreferrer" className={classes.collabLink}>
                        Visit CodeSquareLabs.com <ArrowForwardIcon style={{ fontSize: 16 }} />
                      </a>
                    </Box>
                  </Grow>
                </Grid>
                */}
              </Grid>
            </Container>
          </Box>

          {/* Values Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Our Core Values
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    The principles that guide everything we do
                  </Typography>
                </Box>
              </Slide>

              <Grid container spacing={3}>
                {values.map((value, index) => (
                  <Grid item xs={6} sm={6} md={3} key={index}>
                    <Grow in={true} timeout={800 + index * 150}>
                      <Box className={classes.valueCard}>
                        <Typography className={classes.valueTitle}>
                          {value.title}
                        </Typography>
                        <Typography className={classes.valueText}>
                          {value.text}
                        </Typography>
                      </Box>
                    </Grow>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Box>

          {/* CEO Quote Section */}
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={1000}>
                <Box className={classes.quoteSection}>
                  <FormatQuoteIcon className={classes.quoteIcon} />
                  <TypingQuote
                    text={`"At Arawinz, creativity and commitment sit at the heart of everything we build, and it shows in the results we deliver. We hold ourselves to a high standard, work hard to understand what each client actually needs, and build smarter, more connected products together."`}
                    className={classes.quoteText}
                  />
                  <Typography className={classes.quoteAuthor}>
                    - Dr. P. Srinivas Rao, CEO
                  </Typography>
                </Box>
              </Slide>
            </Container>
          </Box>
        </>
      )}
    </div>
  );
};
